import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useOrderViolationTexts } from '@/intl'
import { preview } from '@/components/form/preview'
import { selectRmVehicles } from '@/features/domain/vehicle'
import { getColorValue } from '@/styles'
import { useTexts } from '../useTexts'
import { SvgIcon } from '@mui/material'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Vehicle(props: Props) {
  const { extOrder } = props

  const vehicles = useSelector(selectRmVehicles)
  const texts = useTexts()

  const { getViolationText } = useOrderViolationTexts()

  const vehicle = useMemo(() => {
    if (!extOrder.order.forceVehicleId) return

    return vehicles[extOrder.order.forceVehicleId]
  }, [extOrder.order.forceVehicleId])

  if (!vehicle) {
    return (
      <preview.Field label={texts.vehicle.label}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  const hasViolations = extOrder.isUnassigned ? false : extOrder.violations?.includes('VE')
  const color = getColorValue(vehicle.color)

  return (
    <preview.Field label={texts.vehicle.label}>
      <preview.ViolationContainer
        violation={
          hasViolations ? <preview.ViolationBadge tooltip={getViolationText('VE')} /> : null
        }
      >
        {color && <VehicleAvatar color={color} />}
        {vehicle.externalId}
      </preview.ViolationContainer>
    </preview.Field>
  )
}

type VehicleAvatarProps = {
  color: string
  borderColor?: string
}

function VehicleAvatar(props: VehicleAvatarProps) {
  const { color, borderColor = '#fff' } = props
  const rad = 12

  return (
    <SvgIcon>
      <circle cx={rad} cy={rad} r={rad} fill={borderColor} />
      <circle cx={rad} cy={rad} r={rad - 2} fill={color} />
    </SvgIcon>
  )
}
